<template>
  <div class="steps-indicator mb-5">
    <div class="columns is-mobile">
      <div class="column" v-for="(step, index) in steps" :key="index">
        <div
          class="step-item"
          :class="{
            'is-active': currentStep === index + 1,
            'is-completed': index + 1 < currentStep,
          }"
          @click="$emit('step-clicked', index + 1)"
        >
          <div class="step-marker">
            <span v-if="index + 1 < currentStep" class="icon">
              <i class="fa fa-check"></i>
            </span>
            <span v-else>{{ index + 1 }}</span>
          </div>
          <div class="step-details">
            <p class="step-title">{{ $t(step.title) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepsIndicator",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },
  emits: ["step-clicked"],
};
</script>

<style scoped>
.steps-indicator {
  margin-bottom: 2rem;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  cursor: pointer;
}

.step-marker {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #dbdbdb;
  color: #363636;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 0.5rem;
  transition: all 0.3s;
}

.step-item.is-active .step-marker {
  background: #3273dc;
  color: white;
}

.step-item.is-completed .step-marker {
  background: #23d160;
  color: white;
}

.step-title {
  font-size: 0.875rem;
  font-weight: 500;
}

.step-item.is-active .step-title {
  color: #3273dc;
  font-weight: 600;
}
</style>
